import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AirportCarPriceService from "../../services/airportcarprice.service";

// Fetch Airport Car Charges
export const getairportCarChargesList = createAsyncThunk(
  "airportCarCharges/getairportCarChargesList",
  async (item, thunkApi) => {
    try {
      const response = await AirportCarPriceService.getairportCarCharges(item);
      return response.data; // Returning the actual response data
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Add Airport Car Charges
export const postairportCarCharges = createAsyncThunk(
  "airportCarCharges/postairportCarCharges",
  async (item, thunkAPI) => {
    try {
      const response = await AirportCarPriceService.addairportCarCharges(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Update Airport Car Charges
export const putairportCarCharges = createAsyncThunk(
  "airportCarCharges/putairportCarCharges",
  async (item, thunkAPI) => {
    try {
      const response = await AirportCarPriceService.editairportCarCharges(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Delete Airport Car Charges
export const deleteairportCarCharges = createAsyncThunk(
  "airportCarCharges/deleteairportCarCharges",
  async (id, thunkAPI) => {
    try {
      const response = await AirportCarPriceService.deleteairportCarCharges(id);
      return id; // Return the ID of the deleted record
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  airportCarCharges: [], // This should be consistent in all reducers
};

const airportCarChargesSlice = createSlice({
  name: "airportCarCharges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // **Handle Fetch**
      .addCase(getairportCarChargesList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getairportCarChargesList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.airportCarCharges = action.payload || []; // ✅ Correctly storing API response
      })
      .addCase(getairportCarChargesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch data";
      })

      // **Handle Add**
      .addCase(postairportCarCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(postairportCarCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.airportCarCharges.push(action.payload); // ✅ Add new entry to the list
      })
      .addCase(postairportCarCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Update**
      .addCase(putairportCarCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(putairportCarCharges.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.airportCarCharges.findIndex(
          (charge) => charge.id === action.payload.id
        );
        if (index !== -1) {
          state.airportCarCharges[index] = action.payload; // ✅ Update existing record
        }
      })
      .addCase(putairportCarCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete**
      .addCase(deleteairportCarCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteairportCarCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.airportCarCharges = state.airportCarCharges.filter(
          (charge) => charge.id !== action.payload
        ); // ✅ Remove from state
      })
      .addCase(deleteairportCarCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default airportCarChargesSlice.reducer;
